<template>
    <div>
        <button type="button" class="btn btn-primary" @click="showInvoiceModal">Add Invoice</button>
        <modal name="add-invoice-modal" height="auto" width="800px" :adaptive="false" :scrollable="true" @closed="clearTemporaryInvoice">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="mt-2 mb-2">New Invoice</h3>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>Order</label>
                                    <select class="form-control" v-model="temporaryInvoice.orderId" :disabled="orderId">
                                        <option v-for="order in orders" v-bind:value="order.id">
                                            #{{ order.number }} ({{ order.domain ? order.domain.name : '' }})
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="getFieldError('orderId')">
                                        {{getFieldError('orderId')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label>From</label>
                                    <datepicker v-model="temporaryInvoice.from" format="yyyy-MM-dd" input-class="form-control"></datepicker>
                                    <small class="text-danger" v-if="getFieldError('from')">
                                        {{getFieldError('from')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label>To</label>
                                    <datepicker v-model="temporaryInvoice.to" format="yyyy-MM-dd" input-class="form-control"></datepicker>
                                    <small class="text-danger" v-if="getFieldError('to')">
                                        {{getFieldError('to')}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label>Rental fee</label>
                                    <select class="form-control" v-model="temporaryInvoice.rentalFee">
                                        <option v-for="article in availableRentalFee" v-bind:value="article.article_id">
                                            {{ article.article_id | mapArticleName}}
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="getFieldError('rentalFee')">
                                        {{getFieldError('rentalFee')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>Description</label>
                                    <input v-model="temporaryInvoice.rentalFeeComment" type="text" class="form-control">
                                    <small class="text-danger" v-if="getFieldError('rentalFeeComment')">
                                        {{getFieldError('rentalFeeComment')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label>Amount (excl. VAT)</label>
                                    <input v-model="temporaryInvoice.rentalFeeCustom" type="number" class="form-control">
                                    <small class="text-danger" v-if="getFieldError('rentalFeeCustom')">
                                        {{getFieldError('rentalFeeCustom')}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label>Ads package</label>
                                    <select class="form-control" v-model="temporaryInvoice.adsPackage">
                                        <option v-for="article in availableAdsPackages" v-bind:value="article.article_id">
                                            {{ article.article_id | mapArticleName}}
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="getFieldError('adsPackage')">
                                        {{getFieldError('adsPackage')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>Description</label>
                                    <input v-model="temporaryInvoice.adsPackageComment" type="text" class="form-control">
                                    <small class="text-danger" v-if="getFieldError('adsPackageComment')">
                                        {{getFieldError('adsPackageComment')}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label>Amount (excl. VAT)</label>
                                    <input v-model="temporaryInvoice.adsPackageCustom" type="number" class="form-control">
                                    <small class="text-danger" v-if="getFieldError('adsPackageCustom')">
                                        {{getFieldError('adsPackageCustom')}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-12">
                                <button type="button" class="submitBtn btn btn-primary float-right mb-3"
                                        @click="sendNewInvoice"
                                        :class="{'loading': loading}"
                                        :disabled="loading"
                                >
                                    <span>Submit</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";

    export default {
        components: {
            Datepicker,
        },
        props: ['name', 'clientId', 'orderId'],
        data() {
            return {
                componentKey: 0,
                articles: [],
                orders: [],
                errors: [],
                temporaryInvoice:{
                    orderId: this.orderId,
                    from: null,
                    to: null,
                    adsPackage: null,
                    adsPackageCustom: 0,
                    adsPackageComment: "",
                    rentalFee: null,
                    rentalFeeCustom: 0,
                    rentalFeeComment: "",
                },
                dateFrom: null,
                dateTo: null,
                loading: false,
            };
        },
        mounted() {
            this.fetchDates().then(() => {
                this.clearTemporaryInvoice();
            }).catch((e) => {
                console.log(e);
            });
            if (this.clientId > 0) {
                this.fetchArticles();
                this.fetchOrders();
            }
        },
        watch: {
            clientId() {
                this.fetchArticles();
                this.fetchOrders();
                this.clearTemporaryInvoice();
            },
            "temporaryInvoice.from": function (newValue){
                this.updateAdsPackageDescription();
                this.updateRentalFeeDescription();
            },
            "temporaryInvoice.to": function (newValue){
                this.updateAdsPackageDescription();
                this.updateRentalFeeDescription();
            },
            "temporaryInvoice.rentalFee": function (newValue){
                let article = this.getArticleById(newValue);
                if(article){
                    if(newValue != 30000){
                        this.temporaryInvoice.rentalFeeCustom = article['sale_price'];
                    }
                    this.updateRentalFeeDescription();
                }
            },
            "temporaryInvoice.adsPackage": function (newValue){
                let article = this.getArticleById(newValue);
                if(article){
                    if(newValue != 30001){
                        this.temporaryInvoice.adsPackageCustom = article['sale_price'];
                    }
                    this.updateAdsPackageDescription();
                }
            },
            "temporaryInvoice.rentalFeeCustom": function (newValue){
                let article = this.getArticleByPrice(this.availableRentalFee, newValue);
                if(article){
                    this.temporaryInvoice.rentalFee = article.article_id;
                }
                if(!article && this.temporaryInvoice.rentalFee != 30000){
                    this.temporaryInvoice.rentalFee = 30000;
                }
            },
            "temporaryInvoice.adsPackageCustom": function (newValue){
                let article = this.getArticleByPrice(this.availableAdsPackages, newValue);
                if(article){
                    this.temporaryInvoice.adsPackage = article.article_id;
                }
                if(!article && this.temporaryInvoice.adsPackage != 30001){
                    this.temporaryInvoice.adsPackage = 30001;
                }
            }
        },
        computed: {
            availableRentalFee(){
                return this.articles.filter(article => article['type'] === "rental_fee");
            },
            availableAdsPackages() {
                return this.articles.filter(article => article['type'] === "ads_package");
            }
        },
        filters: {
            mapArticleName(name){
                if(name == 30000 || name == 30001){
                    return "CUSTOM";
                }
                return name;
            },
        },
        methods: {
            clearErrors(){
                this.errors = {};
            },
            clearTemporaryInvoice(){
                this.temporaryInvoice.orderId = this.orderId;
                this.temporaryInvoice.from = this.dateFrom;
                this.temporaryInvoice.to = this.dateTo;
                this.temporaryInvoice.adsPackageCustom = 0;
                this.temporaryInvoice.rentalFeeCustom = 0;
                this.temporaryInvoice.adsPackage = null;
                this.temporaryInvoice.rentalFee = null;
                this.temporaryInvoice.adsPackageComment = "";
                this.temporaryInvoice.rentalFeeComment = "";
                this.errors = [];
            },
            getFieldError(field){
                if(field in this.errors){
                    return this.errors[field][0];
                }
                return null;
            },
            fetchOrders(){
                axios.get('/client/orders/' + this.clientId).then((res) => {
                    this.orders = res.data;
                }).catch(e => {
                    this.orders = [];
                    console.log(e);
                });
            },
            fetchDates(){
                return new Promise((resolve, reject) => {
                    axios.get('/client/dates/').then((res) => {
                        this.dateFrom = new Date(res.data.from);
                        this.dateTo = new Date(res.data.to);
                        resolve();
                    }).catch(e => {
                        this.dateFrom = null;
                        this.dateTo = null;
                        console.log(e);
                        reject(e);
                    });
                });
            },
            fetchArticles(){
                axios.get('/client/articles/' + this.clientId).then((res) => {
                    this.articles = res.data;
                }).catch(e => {
                    this.articles = [];
                    console.log(e);
                });
            },
            sendNewInvoice(){
                if (confirm('This will create and send an invoice to the customer. Are you sure you want to continue?')) {
                    this.loading = true;
                    const payload = Object.assign({ clientId: this.clientId}, this.temporaryInvoice);
                    axios.post('/client/addInvoice/' + this.clientId, payload).then((res) => {
                        this.clearErrors();
                        this.$emit('invoice-added');
                        this.hideInvoiceModal();
                    }).catch(e => {
                        if(e.response.status === 500){
                            alert(e.response.data.message);
                            return;
                        }
                        this.errors = e.response.data.errors;
                    }).finally(()=>{
                        this.loading = false;
                    });
                }
            },
            getArticleById(id){
                let article = false;
                this.articles.forEach(function(item){
                    if(item.article_id == id){
                        article = item;
                    }
                });
                return article;
            },
            getArticleByPrice(articles, price){
                let article = false;
                articles.forEach(function(item){
                    if(item.sale_price == price){
                        article = item;
                    }
                });
                return article;
            },
            updateAdsPackageDescription(){
                let selectedAdsPackage = this.getArticleById(this.temporaryInvoice.adsPackage);
                let adsPackageDescription = selectedAdsPackage ? selectedAdsPackage.description : "Ads package";
                this.temporaryInvoice.adsPackageComment = this.getDescriptionString(adsPackageDescription);
            },
            updateRentalFeeDescription(){
                let selectedRentalFee = this.getArticleById(this.temporaryInvoice.rentalFee);
                let rentalFeeDescription = "Rental fee";
                if(selectedRentalFee && selectedRentalFee['article_id'] == 30001){
                    rentalFeeDescription += " (custom)";
                }
                this.temporaryInvoice.rentalFeeComment = this.getDescriptionString(rentalFeeDescription);
            },
            getDescriptionString(description){
                let fromString = "-";
                let toString = "-";
                if(this.temporaryInvoice.from instanceof Date){
                    fromString = this.temporaryInvoice.from.toJSON().slice(0,10);
                }

                if(this.temporaryInvoice.to instanceof Date){
                    toString = this.temporaryInvoice.to.toJSON().slice(0,10);
                }
                return description + " (" + fromString + " - " + toString + ")";
            },
            showInvoiceModal(){
                this.clearTemporaryInvoice();
                this.$modal.show('add-invoice-modal');
            },
            hideInvoiceModal(){
                this.$modal.hide('add-invoice-modal');
            },
        },
    }
</script>
<style>
    .vm--modal{
        overflow: visible;
    }
</style>
<style scoped>
    .submitBtn {
        width: 80px;
        position: relative;
    }
    .submitBtn.loading span {
        visibility: hidden;
        opacity: 0;
    }
    .submitBtn.loading::after {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border: 2px solid transparent;
        border-top-color: #ffffff;
        border-radius: 50%;
        animation: button-loading-spinner 1s ease infinite;
    }

    @keyframes button-loading-spinner {
        from {
            transform: rotate(0turn);
        }
        to {
            transform: rotate(1turn);
        }
    }
</style>
